import styled from 'styled-components';

import { Color, FontWeight } from '../../enums';
import { StyledComponent } from '../../interfaces';
import { BoxTitle } from '../boxTitle/boxTitle.component';
import { Image } from '../image/image.component';
import { RadioButton } from '../radioButton/radioButton.component';

export const Container: StyledComponent<'div'> = styled.div`
  width: 100%;
`;

export const ItemDetailsContainer: StyledComponent<'div'> = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 100px;
  border-top: 1px solid ${Color.Gray300};
  border-bottom: 1px solid ${Color.Gray300};
`;

export const ImageElement: StyledComponent<typeof Image> = styled(Image)`
  width: 60px;
  height: 60px;
  object-fit: cover;
`;

export const StyledBoxTitle: StyledComponent<typeof BoxTitle> = styled(BoxTitle)`
  width: 100%; 
  margin-left: 10px;
`;

export const Price: StyledComponent<'div'> = styled.div`
  font-size: 14px;
  font-weight: ${FontWeight.Medium};
  line-height: 18px;
  color: ${Color.Black};
  flex-shrink: 0;
`;

export const StyledRadioButton: StyledComponent<typeof RadioButton> = styled(RadioButton)`
  & + & {
    margin-top: 24px;
  }
`;

export const ShippingOptionsContainer: StyledComponent<'div'> = styled.div`
  padding: 30px 0;
  display: flex;
  flex-direction: column;
`;
